<template>
  <Teleport to="body">
    <Transition name="nc-modal">
      <div v-if="open" class="tw-fixed tw-inset-0 tw-z-[9999] tw-flex tw-items-end sm:tw-items-center tw-justify-center" @click.self="$emit('close')">
        <div class="tw-fixed tw-inset-0 tw-bg-black/40" @click="$emit('close')" />
        <div
          :class="[
            'tw-relative tw-bg-white dark:tw-bg-gray-800 tw-w-full tw-max-h-[90vh] tw-flex tw-flex-col tw-overflow-hidden',
            'tw-rounded-t-2xl sm:tw-rounded-2xl',
            sizeClass,
          ]"
        >
          <!-- Header -->
          <div v-if="title || $slots.header" class="tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-3 tw-border-b tw-border-gray-100 dark:tw-border-gray-700 tw-shrink-0">
            <h3 class="tw-text-base tw-font-semibold tw-text-nc-dark dark:tw-text-white">{{ title }}</h3>
            <button class="tw-w-8 tw-h-8 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-gray-100 dark:tw-bg-gray-700 tw-text-nc-medium active:tw-bg-gray-200" @click="$emit('close')">
              <svg class="tw-w-4 tw-h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"/></svg>
            </button>
          </div>
          <!-- Body -->
          <div class="tw-flex-1 tw-overflow-y-auto tw-p-5">
            <slot />
          </div>
          <!-- Footer -->
          <div v-if="$slots.footer" class="tw-px-5 tw-py-3 tw-border-t tw-border-gray-100 dark:tw-border-gray-700 tw-shrink-0">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
const sizeMap = {
  sm: 'sm:tw-max-w-sm',
  md: 'sm:tw-max-w-lg',
  lg: 'sm:tw-max-w-2xl',
};

export default {
  name: 'NcModal',
  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: '' },
    size: { type: String, default: 'md', validator: v => ['sm', 'md', 'lg'].includes(v) },
  },
  emits: ['close'],
  computed: {
    sizeClass() { return sizeMap[this.size]; },
  },
};
</script>

<style scoped>
.nc-modal-enter-active,
.nc-modal-leave-active {
  transition: opacity 0.2s ease;
}
.nc-modal-enter-active > div:last-child,
.nc-modal-leave-active > div:last-child {
  transition: transform 0.25s ease;
}
.nc-modal-enter-from,
.nc-modal-leave-to {
  opacity: 0;
}
.nc-modal-enter-from > div:last-child {
  transform: translateY(100%);
}
@media (min-width: 640px) {
  .nc-modal-enter-from > div:last-child {
    transform: translateY(20px) scale(0.95);
  }
}
.nc-modal-leave-to > div:last-child {
  transform: translateY(100%);
}
@media (min-width: 640px) {
  .nc-modal-leave-to > div:last-child {
    transform: translateY(20px) scale(0.95);
  }
}
</style>
